import { OreButton, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import SvgEnvelope from '@/Shared/ui/assets/ico_Mail.svg'
import { Trans, useTranslation } from 'react-i18next'
import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { useEffect, useState } from 'react'
import { useRegisterController } from '../hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { useRateLimitedCountdown } from "@/Shared/ui/hooks"
import { useLocation } from 'react-router-dom'
import { registerEmailResend } from '@/Shared/infrastructure/endpoints'
import { HttpMethod } from '@/Shared/domain'
import { createRegisterRepository } from '@/Account/infrastructure/ApiRegisterRepository'
import { RegisterIdentifyModel } from '@/Account/domain'

export const RegisterEmailSuccess = (): JSX.Element => {
  const { t } = useTranslation()
  const location = useLocation()
  const comesFromRegisterFlow = location.state?.fromCreateAccount

  const [affiliateData, setAffiliateData] = useState<RegisterIdentifyModel>({
    email: '',
    backOfficeCompanyId: '',
    legalId: ''
  })

  useEffect(() => {
    setAffiliateData(
      {
        email: location.state?.email,
        backOfficeCompanyId: location.state?.backOfficeCompanyId ?? '',
        legalId: location.state?.legalId ?? ''
      }
    )
  }, [location])

  const {
    formattedMessage,
    startCountdown,
    isBlocked,
    showCountdown,
    isFirstClick,
    setIsFirstClick
  } = useRateLimitedCountdown({
    messageTemplate: t(formTranslation.common.retryBlockMessage),
    params: {
      endpointRoute: `/${registerEmailResend}`,
      endpointActionName: HttpMethod.POST
    },
    needFakeCountdown: true
  })

  const { resendEmail } = useRegisterController(createRegisterRepository())

  return (
    <>
      {comesFromRegisterFlow ? (
        <OreStack placeContent="center" space="large" style={{ maxWidth: '60%', paddingTop: '1rem' }}>
          <OreStack placeItems="center" space="large">
            <img src={SvgEnvelope} alt="Success" />
            <OreStack space="medium" placeItems="center">
              <OreHeading size="headline-lg">{t(LoginTranslation.recovery.emailSent.title)}</OreHeading>
              <OreText style={{ whiteSpace: 'pre-line' }} align="center">
                <Trans t={t}>
                  {t(LoginTranslation.register.emailSent.subtitle, {
                    AFFILIATE_EMAIL: affiliateData.email,
                  })}
                </Trans>
              </OreText>
            </OreStack>
          </OreStack>
          <OreStack placeItems="center" placeContent="center">
            <OreText align="center">
              {t(LoginTranslation.recovery.emailSent.resendCode)} {' '}
              <OreButton
                style={{
                  textDecoration: 'underline',
                  fontFamily: 'Ubuntu, sans-serif',
                  fontWeight: 'normal'
                }}
                onClick={async (e) => {
                  e.currentTarget.blur()
                  if (isFirstClick) {
                    showCountdown()
                    setIsFirstClick(false)
                  } else {
                    await resendEmail(affiliateData)
                    startCountdown()
                  }
                }}
                disabled={isBlocked}
              >
                {t(LoginTranslation.recovery.emailSent.resendCodeLink)}
              </OreButton>
            </OreText>
          </OreStack>
          {isBlocked && (
            <OreStack placeItems="center" placeContent="center">
              <OreText align="center" size="text-xs">
                {formattedMessage}
              </OreText>
            </OreStack>
          )}
        </OreStack>
      ) : (
        <OreText>404 Not Found</OreText>
      )}
    </>
  )
}
